/*!
 * rgv-lazyload.js — reliable lazy-load kick for product imagery.
 *
 * Why this exists: native loading="lazy" is unreliable on this theme's product
 * cards. In slick carousels the slides sit in one very wide translated track so
 * the browser never treats them as near-viewport; in .wow fade-in grids the
 * cards' initial state defers the fetch and it never resumes. The result is
 * product cards that render title + price but a blank image area (seen on the
 * best-sellers carousel AND collection grids).
 *
 * This adds an IntersectionObserver that watches every lazy image and, when one
 * comes within 600px of the viewport, forces the fetch (loading=eager + reassign
 * src/srcset). It only touches images that haven't loaded, so images native lazy
 * handles fine are left alone; lazy behaviour is preserved (nothing loads far
 * off-screen). A MutationObserver catches ajax-injected cards (recently-viewed).
 * No dependencies; no-ops on browsers without IntersectionObserver.
 */
(function () {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;

  var SELECTOR = 'img[loading="lazy"]';
  var kicked = 'rgvLazyKicked';

  function kick(img) {
    if (img.dataset[kicked]) return;
    img.dataset[kicked] = '1';
    if (img.complete && img.naturalWidth > 0) return; // already loaded — leave it
    img.setAttribute('loading', 'eager');
    var src = img.getAttribute('src');
    var srcset = img.getAttribute('srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src); // reassignment restarts the fetch
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        kick(entries[i].target);
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '600px 0px' });

  function observe(root) {
    var imgs = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset[kicked]) continue;
      if (img.complete && img.naturalWidth > 0) continue;
      io.observe(img);
    }
  }

  function start() {
    observe(document);
    // Catch ajax-injected imagery (e.g. recently-viewed slider).
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(SELECTOR)) io.observe(node);
            else if (node.querySelectorAll) observe(node);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
